const FaceBookIcon = (props) => (
  <svg
    width={52}
    height={48}
    viewBox="0 0 52 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={52} height={48} rx={6} fill="url(#paint0_linear_11_546)" />
    <path
      d="M31.1628 25.1615L31.7907 21.3354H28.093V18.6708C28.093 17.5776 28.5116 16.7578 30.186 16.7578H32V13.2733C31.0233 13.1366 29.907 13 28.9302 13C25.7209 13 23.4884 14.913 23.4884 18.3292V21.3354H20V25.1615H23.4884V34.795C24.2558 34.9317 25.0233 35 25.7907 35C26.5581 35 27.3256 34.9317 28.093 34.795V25.1615H31.1628Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11_546"
        x1={1.93715e-7}
        y1={24}
        x2={52}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor={
            process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4264AA"
          }
        />
        <stop
          offset={1}
          stopColor={
            process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#853F89"
          }
        />
      </linearGradient>
    </defs>
  </svg>
);
export default FaceBookIcon;
